import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://oatwrcgucondsxooeyuk.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9hdHdyY2d1Y29uZHN4b29leXVrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM1MzMyODQsImV4cCI6MjA2OTEwOTI4NH0.vYfXWMki5BurQay0OB_avtKBLwOtWinj4UWfEW963EY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey); 